<template>
  <div class="dropdown">
    <div
      id="dropdownUser1"
      aria-expanded="false"
      class="d-block text-decoration-none dropdown-toggle position-relative"
      data-bs-toggle="dropdown"
      style="cursor: pointer"
    >
      <svg
        :style="{
          fill: $page.props.user.roles.includes('tech')
            ? 'var(--forgeron-blue)'
            : $page.props.user.roles.includes('admin')
            ? 'var(--primary-color)'
            : 'var(--text-tertiary-color)',
          left: $page.props.user.profile_pic ? '0.375rem' : '0.5rem',
          top: $page.props.user.profile_pic ? '-0.75rem' : '-0.5rem',
        }"
        style="position: absolute; height: 1rem; width: 1rem"
        viewBox="0 0 32 32"
      >
        <path d="M 32,6 23,15 16,6 9,15 0,6 2,26 30,26 z"></path>
      </svg>
      <img v-if="$page.props.user.profile_pic" :src="$page.props.user.profile_pic" class="profile_pic" />
      <i v-else class="bi bi-person h2"></i>
    </div>
    <ul aria-labelledby="dropdownUser1" class="dropdown-menu dropdown-menu-end shadow">
      <li>
        <a :href="route('home')" class="dropdown-item">zurück zur Startseite</a>
      </li>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li
        v-if="
          $page.props.user.roles.includes('tech') && !$page.props.admin_request && $page.props.user.structures.length
        "
      >
        <div class="dropdown-item">
          <structure-select></structure-select>
        </div>
      </li>
      <li v-if="$page.props.user.roles.includes('tech') && $page.props.user.skins.length">
        <div class="dropdown-item">
          <skin-select></skin-select>
        </div>
      </li>
      <li
        v-if="
          $page.props.user.roles.includes('tech') &&
          ($page.props.user.skins.length || $page.props.user.structures.length)
        "
      >
        <hr class="dropdown-divider mx-0" />
      </li>
      <li
        v-if="
          ($page.props.user.roles.includes('admin') || $page.props.user.roles.includes('tech')) &&
          routePrefix !== 'admin.resources'
        "
      >
        <a href="/admin" class="dropdown-item"> zum ADMIN-Bereich wechseln </a>
      </li>
      <template v-for="(portalData, id) in $page.props.user.portals" :key="id">
        <li v-if="id != $page.props.user.active_portal_id || routePrefix === 'admin.resources'" class="d-flex">
          <a :href="portalData.url" class="dropdown-item d-inline w-auto flex-grow-1">
            {{ portalData.name }}
          </a>
          <a :href="portalData.url + '/admin'" class="dropdown-item d-inline w-auto text-end"> Admin </a>
        </li>
      </template>
      <li>
        <hr class="dropdown-divider" />
      </li>
      <li>
        <a id="logout" :href="route('logout')" class="dropdown-item" @click="logout">abmelden</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import { ref } from 'vue';
import SkinSelect from './SkinSelect';
import StructureSelect from './StructureSelect';

export default {
  components: { StructureSelect, SkinSelect },
  props: {},
  setup() {
    const menuIsOpen = ref(true);

    const toggleMenuOpen = () => {
      menuIsOpen.value = !menuIsOpen.value;
    };

    const logout = (event) => {
      event.preventDefault();
      router.post('/logout', {}, { onSuccess: (window.location.href = '/') });
    };

    return {
      logout,
      menuIsOpen,
      toggleMenuOpen,
    };
  },
};
</script>

<style lang="scss">
.profile_pic {
  border-radius: 50%;
  border: 2px solid #000;
  height: 1.75rem;
  width: 1.75rem;
  &:hover {
    border-color: var(--primary-color) !important;
  }
}
</style>
